export function showStickyContactContent() {
    const stickyContact = document.querySelector('#stickyContact .textcontent:first-child');
    if (stickyContact) {
        const container = stickyContact.closest('#stickyContact');

        stickyContact.addEventListener('click', function () {
            container.classList.toggle('is-active');
        });

        document.addEventListener('click', function (event) {
            if (!container.contains(event.target)) {
                container.classList.remove('is-active');
            }
        });
    }
}